import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAzd_lVpGO1ITL3xSVbtuWsXUzOz3qSMuc",
  authDomain: "jobgenius-a9bef.firebaseapp.com",
  databaseURL: "https://jobgenius-a9bef-default-rtdb.firebaseio.com",
  projectId: "jobgenius-a9bef",
  storageBucket: "jobgenius-a9bef.appspot.com",
  messagingSenderId: "691204924822",
  appId: "1:691204924822:web:140e4dd3096b994fb629b7",
  measurementId: "G-EW5JLPBLBF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const database = getDatabase(app);
const storage = getStorage(app);

// Export both the original names and the new database reference
export const db = database;
export const auth = null; // Since we're not using Firebase Auth
export { database, storage };
export default app;